import { createMultiLevelFetchId, createGetMultiLevelFetch } from '../fetch'

export const createFetchId = createMultiLevelFetchId('pricingContract')

export const getFetchPricingContract =
  createGetMultiLevelFetch('pricingContract')
